import Endpoints from "../../constants/endpoints.js";
import { LocalStorageKeys } from "../../constants/storageKeys.js";
import httpService from "../httpService.js";
import localStorageService from "../localStorageService.js";

const all = async (clientId = null) => {
  clientId =
    clientId ??
    localStorageService.getProperty(LocalStorageKeys.currentClient)?.id;
  const url = Endpoints.products.all.replace("{clientId}", clientId);

  const response = await httpService.get(url);

  console.log("called real allPRodcutcs: ", response.data)

  return response;
};

const create = async (payload) => {
  const clientId = localStorageService.getProperty(
    LocalStorageKeys.currentClient
  )?.id;
  const url = Endpoints.products.create;
  const response = await httpService.post(url, {
    ...payload,
    clientId: clientId,
  });

  return response;
};

/**
 *
 * @param {int} id The product id
 * @returns
 */
const deleteProduct = async (id) => {
  const url = Endpoints.products.delete.replace("{id}", id);
  const response = await httpService.delete(url);

  return response;
};

const get = async (id) => {
  const url = Endpoints.products.get.replace("{id}", id);
  const response = await httpService.get(url);

  return response;
};

/**
 *
 * @param {SearchFilterRequest} filter
 * @returns
 */
const getProducts = async (filter) => {
  const clientId = localStorageService.getProperty(
    LocalStorageKeys.currentClient
  )?.id;
  const url = Endpoints.products.filter.replace("{clientId}", clientId);
  const response = await httpService.post(url, filter);

  return response;
};

const save = async (payload) => {
  return payload?.id > 0 ? await update(payload) : await create(payload);
};

const update = async (payload) => {
  const clientId = localStorageService.getProperty(
    LocalStorageKeys.currentClient
  )?.id;
  const url = Endpoints.products.update.replace("{id}", payload?.id);
  const response = await httpService.put(url, {
    ...payload,
    clientId: clientId,
  });

  return response;
};

//-----------------------------------------//
const productsApiService = {
  all,
  delete: deleteProduct,
  get,
  getProducts,
  save,
};

export default productsApiService;
//-----------------------------------------//
